import * as Types from '../../types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions =  {}
export type DeleteSchoolClassSchoolTagMutationVariables = Types.Exact<{
  schoolTagId: Types.Scalars['Int'];
  schoolClassId: Types.Scalars['Int'];
}>;


export type DeleteSchoolClassSchoolTagMutation = { __typename?: 'Mutation', deleteSchoolClassSchoolTag?: { __typename?: 'schoolsSchoolClassSchoolTag', school_tag_id: number, school_class_id: number } | null | undefined };


export const DeleteSchoolClassSchoolTagDocument = gql`
    mutation DeleteSchoolClassSchoolTag($schoolTagId: Int!, $schoolClassId: Int!) {
  deleteSchoolClassSchoolTag: schoolsDeleteSchoolClassSchoolTag(
    school_tag_id: $schoolTagId
    school_class_id: $schoolClassId
  ) {
    school_tag_id
    school_class_id
  }
}
    `;
export type DeleteSchoolClassSchoolTagMutationFn = Apollo.MutationFunction<DeleteSchoolClassSchoolTagMutation, DeleteSchoolClassSchoolTagMutationVariables>;

/**
 * __useDeleteSchoolClassSchoolTagMutation__
 *
 * To run a mutation, you first call `useDeleteSchoolClassSchoolTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteSchoolClassSchoolTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteSchoolClassSchoolTagMutation, { data, loading, error }] = useDeleteSchoolClassSchoolTagMutation({
 *   variables: {
 *      schoolTagId: // value for 'schoolTagId'
 *      schoolClassId: // value for 'schoolClassId'
 *   },
 * });
 */
export function useDeleteSchoolClassSchoolTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteSchoolClassSchoolTagMutation, DeleteSchoolClassSchoolTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteSchoolClassSchoolTagMutation, DeleteSchoolClassSchoolTagMutationVariables>(DeleteSchoolClassSchoolTagDocument, options);
      }
export type DeleteSchoolClassSchoolTagMutationHookResult = ReturnType<typeof useDeleteSchoolClassSchoolTagMutation>;
export type DeleteSchoolClassSchoolTagMutationResult = Apollo.MutationResult<DeleteSchoolClassSchoolTagMutation>;
export type DeleteSchoolClassSchoolTagMutationOptions = Apollo.BaseMutationOptions<DeleteSchoolClassSchoolTagMutation, DeleteSchoolClassSchoolTagMutationVariables>;